<template>
  <div>
    <content-loader v-if="$apollo.loading" title="Community Podcast" />
    <div v-else>
      <page-header
        :title="'Community Podcast'"
        class="page-banner"
      ></page-header>
      <div class="container">
        <div class="card mt-4 mb-4">
          <div class="card-body">
            <div class="podcast-episode" v-if="podcast">
              <div class="image-box">
                <img v-if="podcast.image_url" :src="podcast.image_url" />
                <img v-else src="@/assets/img/podcast.png" />
              </div>

              <div class="podcast-box">
                <div class="cs-textstyle-paragraph-small-bold">
                  {{ podcast.created_at | moment('MMM DD, YYYY') }}
                </div>
                <div class="cs-textstyle-section-heading mt-2">
                  {{ podcast.title }}
                </div>
                <div class="button-class d-flex flex-row mt-3">
                  <cs-button
                    class="listen-button"
                    :href="podcast.enclosure_url"
                    target="_blank"
                    ><i class="cs-icons-play-filled mr-2"></i>Listen to this
                    episode</cs-button
                  >
                  <div class="cs-textstyle-paragraph ml-3 mt-2">
                    {{ time }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4 ml-1 cs-textstyle-paragraph description">
              {{ podcast.description | text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentLoader from '@/components/global/ContentLoader';
import PageHeader from '@/components/global/PageHeader';
import AppPodcastItemHome from '@/components/home/Podcast';
import GetPodcast from '@/newgql/GetPodcast.gql';

export default {
  name: 'podcast-detail',
  components: {
    PageHeader,
    ContentLoader,
    AppPodcastItemHome
  },
  data() {
    return {};
  },
  apollo: {
    podcast: {
      query: GetPodcast,
      variables() {
        return {
          id: this.$route.params.id
        };
      }
    }
  },
  computed: {
    time() {
      let sec = this.podcast.duration;
      let hours = Math.floor(sec / 3600);
      hours >= 1 ? (sec = sec - hours * 3600) : (hours = '00');
      let min = Math.floor(sec / 60);
      min >= 1 ? (sec = sec - min * 60) : (min = '00');

      min.toString().length == 1 ? (min = '0' + min) : void 0;
      if (hours > 0) {
        return hours + ' hr ' + min + ' mins';
      } else return min + ' mins ';
    }
  }
};
</script>

<style scoped>
img {
  border-radius: 5px;
  height: 180px;
  width: 235px;
  object-fit: cover;
  @include media-breakpoint-up(md) {
    height: 180px;
    width: 235px;
  }
}
.single-line-paragraph {
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
}
.image-box {
  position: relative;
  height: 180px;
}
.description {
  white-space: pre-line;
}
hr {
  margin-left: -1rem !important;
  margin-right: -1rem !important;
}
.col-3 > div:first-child {
  color: var(--cs-gray-05);
}
.podcast-episode {
  display: flex;
  align-items: center;
}
@media (max-width: 767px) {
  .image-box {
    width: 100%;
  }
  .image-box img {
    height: 180px;
    width: 100%;
    object-fit: cover;
  }
  .podcast-box {
    margin-top: 10px;
  }
  .podcast-episode {
    margin-bottom: 20px;
    flex-direction: column;
  }
}
@media (min-width: 768px) {
  .podcast-box {
    margin-left: 15px;
  }
}
</style>
